import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'

export default function TenantDetailsComponent ({selectedProgram}: any) {
  return (
    <>
  
  <AccordionContainer
      child={
          <div className="h-auto w-full bg-white  p-4 rounded">
          <table className="w-full text-xs bg-red-50">
              <thead className="w-full border-y border-black border-opacity-20">
                  <tr className="w-full text-left h-12">
                      <th className="px-3">S.NO</th>
                      <th className="px-3">BusinessName</th>
                      <th className="px-3">Email</th>
                      <th className="px-3">PhoneNumber</th>
                      <th className="px-3">Amount</th>
                      <th className="px-3">Validity</th>
                  </tr>
              </thead>
              <tbody className="w-full h-auto">
                  {selectedProgram?.DBaaSSubscriptions?.map((TranscationItems: any, index: any) => (
                      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                          <td className="px-3">{index + 1}</td>
                          <td className="px-3">{TranscationItems?.BusinessName}</td>
                          <td className="px-3">{TranscationItems?.Email}</td>
                          <td className="px-3">{TranscationItems?.PhoneNumber}</td>
                          <td className="px-3">{TranscationItems?.Amount}</td>
                          <td className="px-3">{TranscationItems?.Validity}</td> 
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
     }
     expandedPanel="Used Tenant Details"
     headerTitle="Used Tenant Details"
   />    
    </>
  )
}